// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/alert.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { Installation } from "./installation_pb";
import { file_api_gateway_v1_installation } from "./installation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/alert.proto.
 */
export const file_api_gateway_v1_alert: GenFile = /*@__PURE__*/
  fileDesc("ChphcGkvZ2F0ZXdheS92MS9hbGVydC5wcm90bxIKZ2F0ZXdheS52MSJHChlHZXRBbGVydExpc3RCeVBhZ2VSZXF1ZXN0EioKCnBhZ2luYXRpb24YASABKAsyFi5nYXRld2F5LnYxLlBhZ2luYXRpb24ifwoaR2V0QWxlcnRMaXN0QnlQYWdlUmVzcG9uc2USLwoNaW5zdGFsbGF0aW9ucxgBIAMoCzIYLmdhdGV3YXkudjEuSW5zdGFsbGF0aW9uEjAKCG1ldGFkYXRhGAIgASgLMh4uZ2F0ZXdheS52MS5QYWdpbmF0aW9uTWV0YWRhdGEycwoMQWxlcnRTZXJ2aWNlEmMKEkdldEFsZXJ0TGlzdEJ5UGFnZRIlLmdhdGV3YXkudjEuR2V0QWxlcnRMaXN0QnlQYWdlUmVxdWVzdBomLmdhdGV3YXkudjEuR2V0QWxlcnRMaXN0QnlQYWdlUmVzcG9uc2VCZQoOY29tLmdhdGV3YXkudjFCCkFsZXJ0UHJvdG9QAaICA0dYWKoCCkdhdGV3YXkuVjHKAgpHYXRld2F5XFYx4gIWR2F0ZXdheVxWMVxHUEJNZXRhZGF0YeoCC0dhdGV3YXk6OlYxYgZwcm90bzM", [file_api_gateway_v1_core, file_api_gateway_v1_installation]);

/**
 * GetAlertListByPageRequest represents a request to retrieve a paginated list of alerts.
 *
 * @generated from message gateway.v1.GetAlertListByPageRequest
 */
export type GetAlertListByPageRequest = Message<"gateway.v1.GetAlertListByPageRequest"> & {
  /**
   * pagination contains the pagination information (page index, page size).
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.GetAlertListByPageRequest.
 * Use `create(GetAlertListByPageRequestSchema)` to create a new message.
 */
export const GetAlertListByPageRequestSchema: GenMessage<GetAlertListByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_alert, 0);

/**
 * GetAlertListByPageResponse represents the response containing a list of alert-related installations and pagination metadata.
 *
 * @generated from message gateway.v1.GetAlertListByPageResponse
 */
export type GetAlertListByPageResponse = Message<"gateway.v1.GetAlertListByPageResponse"> & {
  /**
   * installations is the list of installations with alerts.
   *
   * @generated from field: repeated gateway.v1.Installation installations = 1;
   */
  installations: Installation[];

  /**
   * metadata contains pagination metadata (total count, has more).
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.GetAlertListByPageResponse.
 * Use `create(GetAlertListByPageResponseSchema)` to create a new message.
 */
export const GetAlertListByPageResponseSchema: GenMessage<GetAlertListByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_alert, 1);

/**
 * AlertService provides endpoints for managing and retrieving alerts.
 *
 * @generated from service gateway.v1.AlertService
 */
export const AlertService: GenService<{
  /**
   * GetAlertListByPage retrieves a paginated list of alerts.
   *
   * @generated from rpc gateway.v1.AlertService.GetAlertListByPage
   */
  getAlertListByPage: {
    methodKind: "unary";
    input: typeof GetAlertListByPageRequestSchema;
    output: typeof GetAlertListByPageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_alert, 0);

